import React, { Component } from 'react';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import withScrollToTop from 'client/helpers/withScrollToTop';
import { SCREEN_ID_UTILITY_PROFIT_ADMIN_ADDRESS_RESOLUTION } from 'client/constants/screenIds';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import UPAddressResolutionNoMatchDataTable from 'client/components/UPAddressResolutionNoMatchDataTable/UPAddressResolutionNoMatchDataTable';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_ADDRESS_RESOLUTION)
@withScrollToTop
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
})
class UtilityProfitAdminAddressResolutionPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Address Resolution | Utility Profit',
  });

  render() {

    return (
      <SrPartnerPageV2
        navbarTitle="Utility Profit Address Resolution"
        navbarImage="/images/utility-profit-logo.svg"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
        maxWidth="1200px"
      >
        <SrBox mt="20px">
          <SrFlex justify="between" align="center" columnGap="20px" mb="20px">
            <SrText font="greycliff" size="28" lineHeight="34px" weight="700">
              Address Resolution Dashboard
            </SrText>
          </SrFlex>

          <UPAddressResolutionNoMatchDataTable />
        </SrBox>
      </SrPartnerPageV2>
    );
  }
}

export default UtilityProfitAdminAddressResolutionPage;
